<template>
    <header class="header">
        <a
            id="logo1"
            href="https://www.medienfuehrerschein.bayern/"
            title="Medienführerschein Bayern"
            target="_blank"
        />
        <h1 class="row-1">
            {{ title }}
        </h1>
        <h2 class="row-2">
            <span class="label">
                {{ subtitle }}
            </span>
            <div v-if="progress.active" class="module-progress">
                <ul class="styleless">
                    <li
                        v-for="module in progress.modules"
                        :key="module.key"
                        class="module-progress-item"
                    >
                        <router-link
                            :to="{name: 'module', params: {module: module.key}}"
                        >
                            {{ module.unit }}
                        </router-link>
                    </li>
                </ul>
                <div class="slide-progress">
                    {{ progress.currentSlide }}/{{ progress.slideCount }}
                </div>
            </div>
        </h2>
        <nav>
            <div class="row-1">
                <router-link
                    :to="{name: 'home'}"
                >
                    <span class="home" />
                    Startseite
                </router-link>
                <router-link
                    :to="{name: 'tutorial', params: {slide: 2}}"
                    :class="[onlyHome && 'hidden']"
                >
                    Anleitung
                </router-link>
                <router-link
                    :to="{name: 'imprint'}"
                    :class="[onlyHome && 'hidden']"
                >
                    Impressum
                </router-link>
                <a
                    href="https://www.medienfuehrerschein.bayern/Initiative/97_Datenschutz.htm"
                    target="_blank"
                    :class="[onlyHome && 'hidden']"
                >
                    Datenschutz
                </a>
            </div>
            <div class="row-2">
                <router-link
                    :to="{name: 'linkList', params: {module: linkListModule}}"
                    :class="['button', onlyHome && 'hidden']"
                >
                    Sammelkiste
                    <span v-if="linkListModule">
                        Lerneinheit {{ linkListModule }}
                    </span>
                </router-link>
                <router-link
                    :to="{name: 'personas'}"
                    :class="['button', onlyHome && 'hidden']"
                >
                    Personas
                </router-link>
            </div>
        </nav>
        <a
            id="logo2"
            href="https://www.stiftung-medienpaedagogik-bayern.de/"
            title="Stiftung Medienpädagogik Bayern"
            target="_blank"
        />
    </header>
</template>

<script>
const [headTitleTag] = document.head.getElementsByTagName('title');

export default {
    name: 'Header',
    computed: {
        title()
        {
            return this.$root.header.title;
        },
        subtitle()
        {
            return this.$root.header.subtitle;
        },
        progress()
        {
            return this.$root.header.progress;
        },
        linkListModule()
        {
            return this.$route.params.module;
        },
        onlyHome()
        {
            return this.$root.header.onlyHome;
        }
    },
    watch: {
        title(title)
        {
            headTitleTag.innerHTML = `${title} | Medienführerschein Bayern`;
        }
    }
};
</script>

<style lang="scss" src="./Header.scss" />

